import Box from '@mui/material/Box';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import Grid from '@mui/material/Grid';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { notFound, useQuery } from '../../routes';
import OrgCardView from './OrgCardView';
import { fromAccountUsers, fromAuth, fromOrganizations, useAppDispatch } from '../../store';
import LoadingProgress from '../../layout/LoadingProgress';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.spacing(3),
  },
  container: {
    paddingTop: '1.5rem',
  },
}));

const OrgCardViewManagement = () => {
  const { get } = useQuery();
  const accountId = Number(get('accountId'));
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const user = useSelector(fromAuth.selectUser);
  const isRootOrAdmin = useSelector(fromAuth.selectIsRootOrAdmin);
  const accountUser = useSelector(fromAccountUsers.findAccountUserByAccountId(accountId));
  const accountOrganizations = useSelector(
    fromOrganizations.selectAllByAccountId(accountId),
  );

  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    if (!accountId) return;
    const fetchInfo = async () => {
      await Promise.all([
        dispatch(
          fromOrganizations.doFetchOrganizationByAccountId({ accountId }),
        ),
        dispatch(fromAccountUsers.doGetAccountUsersByUserId({ userId: user!!.id })),
      ]);
      setFetched(true);
    };
    fetchInfo();
  }, [accountId]);

  if (!fetched) return <LoadingProgress />;

  if (!accountUser && !isRootOrAdmin) return <Navigate to={notFound.path} replace />;

  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>
        <FormattedMessage id="organization.card_view.page.header" />
      </Typography>
      <Box className={classes.container}>
        <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
          {
            accountOrganizations.map(organization => (
              <Grid key={organization.id} item xs={12} sm={4} md={4}>
                <OrgCardView orgId={organization.id} />
              </Grid>
            ))
          }
        </Grid>
      </Box>
    </Box>
  );
};

export default OrgCardViewManagement;
